module.exports = __webpack_public_path__ + "img/cpSystemLog.d23734a0.svg";